import React from 'react';
import PropTypes from 'prop-types';

function getMessage(message) {
    let obj = message;

    if (typeof message === 'object' && message.errors) {
        message = [];

        Object.keys(obj.errors).forEach(key => {
            message.push(key + ': ' + obj.errors[key]);
        });
    } else {
        message = [ message ];
    }

    return (
        <div>
            {
                message.map((msg, idx) => {
                    return (
                        <div key={ idx }>
                            { typeof msg === 'string' ? msg : JSON.stringify(Object.values(msg)[0]) }
                        </div>
                    );
                })
            }
        </div>
    );
}

class Error extends React.Component {
    static propTypes = {
        message: PropTypes.any,
        onClose: PropTypes.func
    };

    static defaultProps = {
        onClose: x => x
    };

    close(e) {
        if (e) {
            e.preventDefault();
        }

        this.props.onClose();
    }

    render() {
        const { message } = this.props;

        return (
            <li className="error-box__message" data-test='error-box-message'>
                <a href="#" onClick={ this.close.bind(this)} data-test='error-box-close-button' />
                { getMessage(message) }
            </li>
        );
    }
}

export default Error;
